import React, { useRef, useState } from "react";
import { motion } from "framer-motion";

// Faithful 3D treatment of the official UNGRIP logo: real extrusion via stacked
// layers on the Z axis + tilt toward the pointer. No chrome/neon/glass — just depth,
// shadow and a slow idle float. Preserves lettering, the bitten U and brand colors.
export default function Logo3D({
  src = "/assets/10_logo_ungrip_transparent.png",
  className = "",
  depth = 10,
}) {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ rx: 0, ry: 0 });

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setTilt({ rx: py * -18, ry: px * 22 });
  };
  const reset = () => setTilt({ rx: 0, ry: 0 });

  const layers = Array.from({ length: depth });

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      onTouchStart={reset}
      className={`select-none ${className}`}
      style={{ perspective: "900px" }}
      data-testid="logo-3d"
    >
      <motion.div
        animate={{
          rotateX: tilt.rx,
          rotateY: tilt.ry,
          y: [0, -6, 0],
        }}
        transition={{
          rotateX: { type: "spring", stiffness: 120, damping: 12 },
          rotateY: { type: "spring", stiffness: 120, damping: 12 },
          y: { repeat: Infinity, duration: 5, ease: "easeInOut" },
        }}
        style={{ transformStyle: "preserve-3d", position: "relative", willChange: "transform" }}
      >
        {layers.map((_, i) => {
          const isFront = i === 0;
          return (
            <img
              key={i}
              src={src}
              alt={isFront ? "UNGRIP — MORDI LA VOGLIA" : ""}
              aria-hidden={!isFront}
              draggable={false}
              className={isFront ? "relative w-full h-auto block" : "absolute inset-0 w-full h-full"}
              style={{
                transform: `translateZ(${-i * 3}px)`,
                filter: isFront
                  ? "drop-shadow(0 24px 30px rgba(0,0,0,0.55))"
                  : `brightness(${Math.max(0.18, 1 - i * 0.11)})`,
              }}
            />
          );
        })}
      </motion.div>
    </div>
  );
}
